import React, {PropTypes} from 'react';
import Modal from '../../Modal';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import {ticket} from "../api";
import {sort} from '../helper';

@inject('ticketStore', 'workOrderStore')
@observer
export default class TicketWorkOrderAdd extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = this.props.params.ticket_id ? `/station/${this.props.params.id}/maintenance/ticket/${this.props.params.ticket_id}/view` :`/monitoring/ticket/tabular/${this.props.params.id}/view`;

  @observable selectedWorkOrders = [];

  componentWillMount() {
    const {ticketStore, workOrderStore} = this.props;
    workOrderStore.items.length === 0 && workOrderStore.fetchItems();
    this.selectedWorkOrders = ticketStore.ticket.work_order ? ticketStore.ticket.work_order.map(item => +item.id) : [];
  }

  @action onAddWorkOrder = e => this.selectedWorkOrders.push(+e.target.value);
  @action onRemoveWorkOrder = id => this.selectedWorkOrders = this.selectedWorkOrders.filter(item => +item !== +id);

  onSave = () => {
    const {notify, router} = this.context;
    const {params: {ticket_id, id}} = this.props;
    ticket.workOrder.save(ticket_id || id, toJS(this.selectedWorkOrders)).then(res => {
      notify.success(res);
      router.push(this.slug)
    }).catch(notify.error)
  };

  render() {
    const {workOrderStore} = this.props;
    let unSelectedWorkOrders = this.selectedWorkOrders && workOrderStore.items.filter(item => {
      if(this.selectedWorkOrders.indexOf(+item.id) === -1) return item.id;
    });

    return (
      <Modal slug={this.slug} title='Add/Remove Work Order'>
        <div>
          <select value="0" onChange={this.onAddWorkOrder} style={{width:'70%'}}>
            <option value="0">Add Work Order</option>
            {sort(unSelectedWorkOrders).map((item, index) => (
              <option key={index} value={item.id}>[{item.id}] {item.title}</option>
            ))}
          </select><br/><br/>
          <div className='DataTable'>
            <table>
              <thead>
              <tr>
                <th>Work Order Number</th>
                <th>{}</th>
              </tr>
              </thead>
              <tbody>
              {sort(this.selectedWorkOrders).map((item, i) => {
                const correspondingWorkOrder = workOrderStore.items.find(workOrder => +workOrder.id === +item);

                return <tr key={`ticket_work_order_${i}`} className="childRow" style={{height: '30px'}}>
                <td>{correspondingWorkOrder ? `[${correspondingWorkOrder.id}] ${correspondingWorkOrder.title}` : item}</td>
                <td className='crudActions'><a onClick={() => this.onRemoveWorkOrder(item)}><i className='fa fa-remove'/></a></td>
              </tr>}
              )}
              </tbody>
            </table>
            <div className="tableActions">
              <button className="button" onClick={this.onSave}>Save</button>
            </div>
          </div>
          <br/>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketWorkOrderAdd.js